export var Device;
(function (Device) {
    Device["PC"] = "pc";
    Device["MOBILE"] = "mobile";
})(Device || (Device = {}));
